import BlackOutlinedButton from "theme/components/buttons/styledButtons/BlackOutlinedButton";
import BlackSolidButton from "theme/components/buttons/styledButtons/BlackSolidButton";
import BlueSolidButton from "theme/components/buttons/styledButtons/BlueSolidButton";
import Button from "theme/components/buttons/Button";
import DarkGreenOutlinedButton from "theme/components/buttons/styledButtons/DarkGreenOutlinedButton";
import DarkGreenSolidButton from "theme/components/buttons/styledButtons/DarkGreenSolidButton";
import DarkGreigeSolidButton from "theme/components/buttons/styledButtons/DarkGreigeSolidButton";
import GreigeSolidButton from "theme/components/buttons/styledButtons/GreigeSolidButton";
import LightGreenSolidButton from "theme/components/buttons/styledButtons/LightGreenSolidButton";
import PropTypes from "prop-types";
import React from "react";
import RedSolidButton from "theme/components/buttons/styledButtons/RedSolidButton";
import TransparentButton from "theme/components/buttons/styledButtons/TransparentButton";
import WhiteOutlinedButton from "theme/components/buttons/styledButtons/WhiteOutlinedButton";
import WhiteSolidButton from "theme/components/buttons/styledButtons/WhiteSolidButton";

export const buttons = {
    black_outlined: BlackOutlinedButton,
    black_solid: BlackSolidButton,
    white_outlined: WhiteOutlinedButton,
    white_solid: WhiteSolidButton,
    blue_solid: BlueSolidButton,
    transparent: TransparentButton,

    // Components below shall be removed
    red_solid: RedSolidButton,
    dark_green_outlined: DarkGreenOutlinedButton,
    dark_green_solid: DarkGreenSolidButton,
    light_green_solid: LightGreenSolidButton,
    greige_solid: GreigeSolidButton,
    dark_greige_solid: DarkGreigeSolidButton,
};

const ThemeButton = ({ buttonTheme, ...rest }) => {
    // We decide button by buttonTheme, but if the buttonTheme button does not exist, we take the first in the list.
    // This is to ensure that the buttons does not crash the content.
    const RenderButton = buttons[buttonTheme] || buttons[Object.keys(buttons)[0]];
    return <RenderButton {...rest} />;
};

ThemeButton.propTypes = {
    ...Button.propTypes,
    buttonTheme: PropTypes.oneOf(Object.keys(buttons)),
};

ThemeButton.defaultProps = {
    ...Button.defaultProps,
    buttonTheme: Object.keys(buttons)[0],
};

export default ThemeButton;
